@if (error && derrors) {
  <info [option]="optionInfo1">
    {{ error.message }}
  </info>
}
<joint-ownership-form
  [formGroup]="form"
  formArrayName="prestationJointOwnershipList"
  [derrors]="derrors"
></joint-ownership-form>
